export default "/images/attendance-large.svg?ea659924d26dba6e8e574779c14d3eb2";